//dependencies

//services
import recaptcha from "emun.auth/recaptcha/recaptcha.service";
import "emun.auth/recaptcha/recaptcha.scss";

//components

export const dependencies = [];

export const modules = {};

export const services = {};

export const runners = {
  init: () => recaptcha.init(),
};

export const components = {};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  runners,
};
